import React from "react";

import { StyledSVG } from "../StyledIcon";

export const EquipmentIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <rect width="60" height="60" fill="white" />
      <path
        d="M52 40V14C52 12.8954 51.1046 12 50 12H10C8.89543 12 8 12.8954 8 14V40"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M4 43H56V44C56 46.2091 54.2091 48 52 48H8C5.79086 48 4 46.2091 4 44V43Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M21 33L32.0036 26.6471"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M34.8564 25L38.3205 23"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
